import { useEffect, useState } from "react";
import api from "@/lib/api";
import { waLink } from "@/lib/whatsapp";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MessageCircle, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";

const STATUSES = ["New", "Contacted", "Follow-up", "Converted", "Closed"];
const TYPES = [["all", "All"], ["whatsapp", "WhatsApp"], ["consultant", "Consultant"], ["contact", "Contact"]];

export default function AdminEnquiries() {
  const [list, setList] = useState(null);
  const [type, setType] = useState("all");
  const load = () => api.get(`/admin/enquiries?type=${type}`).then((r) => setList(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [type]);
  const setStatus = (id, status) => api.put(`/admin/enquiries/${id}/status`, { status }).then(() => { toast.success("Updated"); load(); });
  const del = (id) => { if (!window.confirm("Delete this enquiry?")) return; api.delete(`/admin/enquiries/${id}`).then(() => { toast.success("Enquiry deleted"); load(); }); };

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="font-heading text-3xl lg:text-4xl text-forest tracking-tight">Enquiries</h1>
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="w-[180px] rounded-full bg-white border-sage" data-testid="enquiry-filter"><SelectValue /></SelectTrigger>
          <SelectContent>{TYPES.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {!list ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-forest" /></div> :
        list.length === 0 ? <p className="text-center py-16 text-muted-foreground">No enquiries.</p> : (
        <div className="space-y-3">
          {list.map((e) => (
            <div key={e.id} className="bg-white rounded-2xl soft-shadow p-5" data-testid={`enquiry-${e.id}`}>
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs bg-sage/20 text-forest px-2 py-0.5 rounded-full">{e.type.replace("_", " ")}</span>
                    <span className="font-500 text-ink">{e.name || "Guest"}</span>
                    {e.phone && <span className="text-sm text-muted-foreground">{e.phone}</span>}
                  </div>
                  {e.consultant_name && <p className="text-sm text-brown mt-1">Consultant: <b>{e.consultant_name}</b> {e.wellness_area && `• ${e.wellness_area}`}</p>}
                  {e.product_name && <p className="text-sm text-brown mt-1">Product: <b>{e.product_name}</b></p>}
                  {e.message && <p className="text-sm text-brown/70 mt-1">{e.message}</p>}
                  <p className="text-xs text-muted-foreground mt-1">{e.created_at?.slice(0, 16).replace("T", " ")}</p>
                </div>
                <div className="flex items-center gap-2">
                  {e.phone && <a href={waLink(e.phone, `Hi ${e.name}, this is LIVENEAT Organic.`)} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center"><MessageCircle className="w-4 h-4 text-white" /></a>}
                  <Select value={e.status} onValueChange={(v) => setStatus(e.id, v)}>
                    <SelectTrigger className="h-9 w-[130px] rounded-full bg-sand border-0 text-xs" data-testid={`enquiry-status-${e.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                  <button onClick={() => del(e.id)} data-testid={`enquiry-delete-${e.id}`} className="w-9 h-9 rounded-full border border-sage flex items-center justify-center hover:bg-sand" title="Delete enquiry"><Trash2 className="w-4 h-4 text-terracotta" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
